import BulkImportTypes from '../components/atoms/bulkImport/bulkImportTypes';
import { ButtonTheme } from '../components/atoms/button/button';
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import routes from '../routes/route';
import viewAppAreas from './viewRelatedAppAreas';
import viewRelatedRoomTags from './viewRelatedRoomTags';
import viewRelatedSportRoomTags from './viewRelatedSportRoomTags';

export default {
  attributeName: 'youtubeCategory',
  isDragable: false,
  canOpen: true,
  canEdit: true,
  canCreate: false,
  canRemove: true,
  createPath: routes.YOUTUBE_INTERACTABLES_NEW,

  editURL: routes.YOUTUBE_CATEGORIES_EDIT,
  // bulkSelectable:true,
  // bulkButtons:[
  //   {label:"Import sportroom",
  //   color:ButtonTheme.INFO,
  //   action:"bulkImport",
  //   actionUrl:"appConfig/bulkImport",
  //   type:BulkImportTypes.SPORTROOMCONFIG,
  //   title:"Import elements",
  //   showNumberElems:false,
  //   hidden:'never',
  //   sessionParams: ['appId'],
  //   formConfig:[
  //     {
  //       attributeName: 'type',
  //       helpText: 'Type of import',
  //       type: FormInputTypes.TEXT_INPUT.TEXT,
  //       required: true,
  //       label: 'Type',
  //       defaultValue:BulkImportTypes.SPORTROOMCONFIG,
  //       // hidden:true
  //     },
  //     {
  //       attributeName: 'config',
  //       helpText: 'Select a valid config for the app selected, or set All for all the possible configs of the app',
  //       type: FormInputTypes.SELECT,
  //       label: 'Config',
  //       placeholder: 'Please enter to add a valid config',
  //       multiple: false,
  //       disabledWhenEdit:true,
  //       url: 'appConfigslist/appId',
  //       // parentField:'app',
  //       enabledWhen:{"field":"app","notValues":['(Empty)']},
  //       emptyValue:true,
  //       // childField:'appCategories',
  //       default:'(Empty)', //default value to empty option
  //       allValue:'(All)',
  //       fieldValue:'id',
  //       fieldName:'name',
  //       asyncSelect: true,
  //       options:[],
  //       session: ['appId'],
  //     },
  //   ]
  // },
  //     {label:"Delete",
  //       color:ButtonTheme.ERROR,
  //       action:"bulkDelete",
  //       title:"Select records to delete",
  //       showNumberElems:true,
  //       disabled:'no-selection',
  //       hidden:'no-selection'
  //     },
  //     {label:"Clone",
  //       color:ButtonTheme.DARK,
  //       action:"bulkClone",
  //       title:"Clone records",
  //       showNumberElems:true,
  //       disabled:'no-selection',
  //       hidden:'no-selection'
  //     },
  //     {label:"Export",
  //       color:ButtonTheme.INFO,
  //       action:"bulkExport",
  //       title:"Export records",
  //       showNumberElems:true,
  //       disabled:'no-selection',
  //       hidden:'no-selection'
  //     }],
  // isMultiSelectable:true,
  emptyMessage: "You don't have categories, click on the \"+\" icon to create one.",
  fields: [
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: true,
      canEdit: false,
      canCreate: true,
      canOpen: true,
      canFilter: true,
      helpText: 'Name of the app.',
    },
    // {
    //   attributeName: 'appTags',
    //   label: 'Tags',
    //   type: FormInputTypes.RELATIONSHIPFILTER,
    //   canEdit: true,
    //   canCreate: true,
    //   canFilter: false,
    //   configFile: viewRelatedRoomTags,
    //   filterByParticularId:{"field":"appId","value":"id"},
    //   default: [],
    //   helpText: 'Video categories joined.',
    //   width: '30rem',

    // },
  ],
};
